/*
 |--------------------------------------------------------------------------
 | Bootstrap The Application
 |--------------------------------------------------------------------------
 |
 | First we will load all of this project's JavaScript dependencies which
 | includes Vue and other libraries. It is a great starting point when
 | building robust, powerful web applications using Vue and Laravel.
 |
 */

require('./bootstrap');

/*
 |--------------------------------------------------------------------------
 | Custom Elements
 |--------------------------------------------------------------------------
 |
 | Here we'll set up the custom components, plugins, and section specific
 | javascript files that are going to be needed to run our application
 | this is a nice place to require all sorts of custom jQuery code.
 |
 */

require('./support/Collapse');
require('./support/Dropdown');
require('./support/Tab');

/*
 |--------------------------------------------------------------------------
 | Custom Elements
 |--------------------------------------------------------------------------
 |
 | Here we'll set up the custom components, plugins, and section specific
 | javascript files that are going to be needed to run our application
 | this is a nice place to require all sorts of custom jQuery code.
 |
 */

require('./html/alerts');
require('./html/carousel');
require('./html/cookies');
require('./html/forms');
require('./html/menu');
require('./html/modals');
require('./html/share');
require('./html/video');
require('./html/filters');
require('./html/passive');

/*
 |--------------------------------------------------------------------------
 | Setup The Vue Instance
 |--------------------------------------------------------------------------
 |
 | Next, we will create a fresh Vue application instance and attach it to
 | the page. Then, you may begin adding components to this application
 | or customize the JavaScript scaffolding to fit your unique needs.
 |
 */

import LoginModal from './components/LoginModal.vue';
import NavbarDropdown from './components/NavbarDropdown.vue';
import OpenpayTokenizationForm from './components/OpenpayTokenizationForm.vue';
import PasswordToggle from './components/PasswordToggle.vue';
import InputPassword from './components/InputPassword.vue';
import SaveArticleButton from './components/SaveArticleButton.vue';
import UserCard from './components/UserCard.vue';

new Vue({
    el: '#app',
    components: {
        'login-modal': LoginModal,
        'navbar-dropdown': NavbarDropdown,
        'openpay-tokenization-form': OpenpayTokenizationForm,
        'input-password': InputPassword,
        'password-toggle': PasswordToggle,
        'save-article-button': SaveArticleButton,
        'user-card': UserCard,
    },
});
